'use strict';

import TS from '@zerolight/zlthunder-time-utils';
import {formatDate, PrettyDateFormat} from '../../shared/formatters';
import numeral from 'numeral';
import React, {useMemo} from 'react';

function Num({children}) {
	let n = Number(children);
	if (isNaN(n) || n === Infinity || n === -Infinity) {
		return null;
	}

	return numeral(n).format('0,0');
}

function Dt({children}) {
	if (children === null) {
		return null;
	}

	let dt = TS.validate(children);
	if (isNaN(dt.valueOf())) {
		return null;
	}

	return formatDate(dt, PrettyDateFormat);
}

function Legend({data, cursor, staple}) {
	let legendData = useMemo(() => {
		if (!data) {
			return null;
		}

		let cursorLookup = new Map();
		let rows = new Map();

		for (let s of data.values()) {
			let {node: {id}, type, series} = s;
			let total = 0;
			let min = Infinity;
			let max = -Infinity;
			let median = [];

			for (let {ts, count} of series) {
				ts = TS.validate(ts).valueOf();
				if (isNaN(count) || isNaN(ts)) {
					continue;
				}

				total += count;
				min = Math.min(min, count);
				max = Math.max(max, count);
				median.push(count);

				let lookup = cursorLookup.get(ts) || new Map();
				lookup.set(id, count);
				cursorLookup.set(ts, lookup);
			}
			rows.set(id, {type: type.join('.'), total, min, max, median: median[Math.floor(median.length / 2)]});
		}
		return {rows, cursorLookup};
	}, [data]);

	if (!legendData) {
		return null;
	}

	let {rows, cursorLookup} = legendData;

	return (
		<table className="cm-table table table-stripped">
			<thead>
				<tr>
					<th>Event</th>
					<th><Dt>{staple}</Dt></th>
					<th><Dt>{cursor}</Dt></th>
					<th>Total</th>
					<th>Minimum</th>
					<th>Maximum</th>
					<th>Median</th>
				</tr>
			</thead>
			<tbody>
				{Array.from(rows.entries())
					.map(([id, row]) => {
						let valuesAtCursor = cursor && cursorLookup.get(cursor.valueOf());
						let valuesAtStaple = staple && cursorLookup.get(staple.valueOf());
						return (
							<tr key={id}>
								<td>{row.type}</td>
								<td><Num>{valuesAtStaple && valuesAtStaple.get(id)}</Num></td>
								<td><Num>{valuesAtCursor && valuesAtCursor.get(id)}</Num></td>
								<td><Num>{row.total}</Num></td>
								<td><Num>{row.min}</Num></td>
								<td><Num>{row.max}</Num></td>
								<td><Num>{row.median}</Num></td>
							</tr>
						)
					})
				}
			</tbody>
		</table>
	);

}

export default Legend;